<div class="view-extended-report">
    <div class="view-extended-report__block-header">
      <button class="common-button__text-noborder"
        (click)="handleDismiss()">
          <span class="common-button__text-title"
            [afTranslate]="'view-extended-report.close-extended-view'">_Cerrar vista ampliada</span>
          <i class="lf-icon-zoom-out common-icon__md"></i>
      </button>
    </div>
    @if(type==='result-report'){
      <div class="results-report__graph-header-block">
        <p class="results-report__graph-header-group-text">
          <span>{{additionalInfo.groupName}}</span>
          @if(additionalInfo.subGroupName !== ''){
            <span> > {{additionalInfo.subGroupName}} </span>
          }
        </p>
        <p class="results-report__graph-header-group-text results-report__graph-header-group-text--title">
          {{additionalInfo.label}}
        </p>
        <p class="results-report__graph-header-group-text results-report__graph-header-group-text--more">
          {{additionalInfo.optionMoreSelected}}
        </p>
      </div>
      @if(graphData?.amount > 0){
        <horizontal-poll-graph [graphData]="graphData"
          [isModal]="isModal">
        </horizontal-poll-graph>
      }
      <div class="view-extended-report__info-block">
        <div class="view-extended-report__info-block-answered">
          <span><span [afTranslate]="'results-report.answered'">_Respondido</span>:</span>
          <span>{{additionalInfo.answered}}</span>
        </div>
        <div class="view-extended-report__info-block-omitted">
          <span><span [afTranslate]="'results-report.omitted'">_Omitido</span>:</span>
          <span>{{additionalInfo.notAnswered}}</span>
        </div>
      </div>
    }@else {
      <div class="risk-bar-graph-modal">
        <div class="report-graphs__graph-header">
          <p class="report-graphs__graph-header-title" [afTranslate]="'report-graph.inherent-risk'"></p>
          <button class="common-button__link"
            (click)="saveAsPng('report-graph-inherent', '.risk-bar-graph-modal')"
            [id]="'report-graph-inherent'"
            [disabled]="disabledSaveAsPng"
            [tooltipDisabled]="!showTooltip"
            [pTooltip]="'results-report.image-captured' | afTranslate"
            tooltipPosition="top"
            tooltipEvent="focus">
            <span class="common-button__link-text"
              [afTranslate]="'results-report.capture-image'">_Capturar tabla de datos</span>
          </button>
        </div>
        <risk-bar-graph [graphData]="graphData"
          [isModal]="isModal"></risk-bar-graph>
      </div>

    }

</div>
